'use strict';

(function () {

	if (!customElements.get('image-comparison')) {
		class ImageComparison extends HTMLElement {
			constructor() {
				super();
				this.slider = this.querySelector(".image-comparison__range");
				this.sliderButton = this.querySelector('.image-comparison__slider');
				this.beforeImage = this.querySelector(".image-comparison__slider-wrapper .image--before");
				this.afterImage = this.querySelector(".image-comparison__slider-wrapper .image--after");
				this.hasAnimated = false;

				this.init();
			}

			init() {
				if (!this.slider) return;

				// Event listeners per l'interazione manuale
				this.slider.addEventListener("input", () => {
					this.moveSlider();
					this.trackSliderMovement();
					this.hasAnimated = true;
				});

				this.slider.addEventListener('mousedown', () => {
					this.hasAnimated = true;
				});
				
				this.slider.addEventListener('touchstart', () => {
					this.hasAnimated = true;
				});

				this.moveSlider();
				this.trackSliderMovement();

				// Configura l'Intersection Observer per l'animazione automatica
				this.setupIntersectionObserver();
			}

			moveSlider() {
				const value = this.slider.value;
				this.beforeImage.style.clipPath = `inset(0 ${100 - value}% 0 0)`;
				this.afterImage.style.clipPath = `inset(0 0 0 ${value}%)`;

				const percent = (value - this.slider.min) / (this.slider.max - this.slider.min) * 100;
				this.sliderButton.style.setProperty('--percent', `${percent}%`);
			}

			trackSliderMovement() {
				this.classList.add("js-active"); 

				const value = this.slider.value;
				const isNarrowScreen = window.innerWidth < 990;

				if (isNarrowScreen && value >= 50) {
					this.classList.add("slider-high-value");
				} else {
					this.classList.remove("slider-high-value");
				}

				clearTimeout(this.activeTimeout);
				this.activeTimeout = setTimeout(() => {
					this.classList.remove("js-active");
				}, 500);
			}

			setupIntersectionObserver() {
				const options = {
					root: null,
					rootMargin: '0px',
					threshold: 0.3
				};

				const observer = new IntersectionObserver((entries) => {
					entries.forEach(entry => {
						if (entry.isIntersecting && !this.hasAnimated) {
							this.hasAnimated = true;
							this.playIntroAnimation();
						}
					});
				}, options);

				observer.observe(this);
			}

			playIntroAnimation() {
				setTimeout(() => {
					this.animateToLeft();
				}, 600);
			}

			// Easing super smooth - easeInOutSine
			easeInOutSine(x) {
				return -(Math.cos(Math.PI * x) - 1) / 2;
			}

			// Fase 1: Vai a sinistra (35%)
			animateToLeft() {
				const startValue = 50;
				const endValue = 15;
				const duration = 500;
				const startTime = performance.now();

				const animate = (currentTime) => {
					const elapsed = currentTime - startTime;
					const progress = Math.min(elapsed / duration, 1);
					const easedProgress = this.easeInOutSine(progress);

					const currentValue = startValue + (endValue - startValue) * easedProgress;
					this.updateSliderValue(currentValue);

					if (progress < 1) {
						requestAnimationFrame(animate);
					} else {
						setTimeout(() => {
							this.animateToRight();
						}, 250);
					}
				};

				requestAnimationFrame(animate);
			}

			// Fase 2: Vai a destra (65%)
			animateToRight() {
				const startValue = 15;
				const endValue = 85;
				const duration = 1000;
				const startTime = performance.now();

				const animate = (currentTime) => {
					const elapsed = currentTime - startTime;
					const progress = Math.min(elapsed / duration, 1);
					const easedProgress = this.easeInOutSine(progress);

					const currentValue = startValue + (endValue - startValue) * easedProgress;
					this.updateSliderValue(currentValue);

					if (progress < 1) {
						requestAnimationFrame(animate);
					} else {
						setTimeout(() => {
							this.animateToCenter();
						}, 250);
					}
				};

				requestAnimationFrame(animate);
			}

			// Fase 3: Torna al centro (50%)
			animateToCenter() {
				const startValue = 85;
				const endValue = 50;
				const duration = 1000;
				const startTime = performance.now();

				const animate = (currentTime) => {
					const elapsed = currentTime - startTime;
					const progress = Math.min(elapsed / duration, 1);
					const easedProgress = this.easeInOutSine(progress);

					const currentValue = startValue + (endValue - startValue) * easedProgress;
					this.updateSliderValue(currentValue);

					if (progress < 1) {
						requestAnimationFrame(animate);
					}
				};

				requestAnimationFrame(animate);
			}

			updateSliderValue(value) {
				this.slider.value = value;
				this.moveSlider();
			}
		}
	
		customElements.define('image-comparison', ImageComparison);
	}
})();